import DfpAdSlot from "./DfpAdSlot"
export default DfpAdSlot
